<div class="customer-appointments-page">
  @if (isLoading) {
    <app-loader></app-loader>
  }

  <section class="overview-hero">
    <div class="hero-copy">
      <span class="hero-kicker">Appointments</span>

      <h1>Your <span>Appointments</span></h1>

      <p>
        Review upcoming bookings, completed visits, cancellations, salon
        details, and appointment value from one place.
      </p>
    </div>

    <div class="hero-actions">
      <button
        type="button"
        class="overview-btn overview-btn--dark"
        (click)="loadAppointments()"
      >
        Refresh
      </button>
    </div>
  </section>

  <section class="kpi-grid">
    <article class="kpi-card kpi-card--primary">
      <div>
        <span>Total Appointments</span>
        <strong>{{ appointments.length }}</strong>
        <p>All bookings currently visible in your account.</p>
      </div>

      <img [src]="assetUrl + 'icons/calendar-border.svg'" alt="" />
    </article>

    <article class="kpi-card">
      <div>
        <span>Upcoming</span>
        <strong>{{ getUpcomingAppointmentsCount() }}</strong>
        <p>Confirmed or pending bookings still ahead.</p>
      </div>

      <img [src]="assetUrl + 'icons/doc-border.svg'" alt="" />
    </article>

    <article class="kpi-card">
      <div>
        <span>Completed</span>
        <strong>{{ completedAppointments }}</strong>
        <p>Appointments marked as completed.</p>
      </div>

      <img [src]="assetUrl + 'icons/review-border.svg'" alt="" />
    </article>

    <article class="kpi-card">
      <div>
        <span>Total Spend</span>
        <strong>{{ totalSpend | currency }}</strong>
        <p>{{ averageSpend | currency }} average appointment value.</p>
      </div>

      <img [src]="assetUrl + 'icons/dollar-border.svg'" alt="" />
    </article>
  </section>

  <section class="metric-grid">
    <article class="metric-card metric-card--success">
      <span>Confirmed</span>
      <strong>{{ confirmedAppointments }}</strong>
      <p>Bookings confirmed by the salon.</p>
    </article>

    <article class="metric-card metric-card--warning">
      <span>Pending</span>
      <strong>{{ pendingAppointments }}</strong>
      <p>Bookings waiting for confirmation.</p>
    </article>

    <article class="metric-card metric-card--danger">
      <span>Cancelled</span>
      <strong>{{ cancelledAppointments }}</strong>
      <p>Appointments that were cancelled.</p>
    </article>
  </section>

  <section class="panel">
    <header class="panel-head">
      <div>
        <span class="panel-kicker">Booking History</span>
        <h2>Your Appointment List</h2>
        <p>Open an appointment to see services, location, and full details.</p>
      </div>

      <span class="count-pill">
        {{ getUpcomingAppointmentsCount() }} upcoming
      </span>
    </header>

    @if (error) {
      <div class="empty-state">
        <strong>Unable to load appointments</strong>
        <p>{{ error }}</p>

        <button
          type="button"
          class="overview-btn overview-btn--dark"
          (click)="loadAppointments()"
        >
          Retry
        </button>
      </div>
    } @else if (appointments.length === 0) {
      <div class="empty-state">
        <img [src]="assetUrl + 'icons/calendar.svg'" alt="" />
        <strong>No appointments yet</strong>
        <p>
          You do not have any appointments scheduled. Book your first
          appointment to get started.
        </p>
      </div>
    } @else {
      <div class="appointment-list">
        @for (appointment of appointments; track appointment.appointment_id) {
          <article class="appointment-card">
            <div class="date-card">
              <span>{{ formatDatePart(appointment.start_time, "MMM") }}</span>
              <strong>{{
                formatDatePart(appointment.start_time, "dd")
              }}</strong>
            </div>

            <div class="appointment-info">
              <div class="appointment-meta">
                <span>
                  {{ formateDate(appointment.start_time) }} at
                  {{ formateTime(appointment.start_time) }}
                </span>

                <span
                  class="status-pill"
                  [ngClass]="statusClass(appointment.status)"
                >
                  {{ capitalizedStatus(appointment.status) }}
                </span>
              </div>

              <h3>{{ appointment?.salon?.name || "Salon Appointment" }}</h3>

              <p>
                {{ appointment?.salon?.address || "No address" }},
                {{ appointment?.salon?.city || "No city" }}
              </p>
            </div>

            <div class="appointment-action">
              <strong>{{ appointment?.total_price | currency }}</strong>

              <a
                [routerLink]="[
                  '../appointment/details',
                  appointment.appointment_id,
                ]"
                class="overview-btn overview-btn--dark"
              >
                See Details
              </a>
            </div>
          </article>
        }
      </div>
    }
  </section>
</div>
